import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=6e9ec040&scoped=true"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"
import style0 from "./AboutMain.vue?vue&type=style&index=0&id=6e9ec040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9ec040",
  null
  
)

export default component.exports
import {QCard,QCardSection,QParallax,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QParallax,QImg})
